import React, { useEffect, useState } from "react";
import AirportForm from "../components/airportForm";
import { AirportListRoute } from "../../../routesConstants";
import { useParams } from "react-router-dom";
import BlockUi from "@availity/block-ui";
import {Helmet} from "react-helmet";
import axios from "../../../../helpers/axios";
import {useNavigate} from "react-router";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {renderLocationsLinks} from "../../city/pages/edit";

const CityEditPage = () => {
  const [airport, setAirport] = useState(null);
  const [loader, setLoader] = useState(false);
  const navigation = useNavigate()
  const { id } = useParams();
  useEffect(() => {
    if (airport === null) {
      setLoader(true);
      axios.get("/api/locations/airports/"+id)
        .then(({data})=>{
          setAirport(data.data)
          console.log(data.data)
        })
        .finally(()=>setLoader(false))
    }
  }, [airport, id]);
  const callback = (values, cb) => {
    setLoader(true)
    axios.patch("/api/locations/airports/" + id, values)
      .then(()=>navigation(AirportListRoute)).
    finally(()=>setLoader(false))
  };
  const deleteAction = () => {
    if(window.confirm('Вы точно хотите удалить?')){
      setLoader(true);
      axios.delete("/api/locations/airports/" + id,)
        .then(()=>navigation(AirportListRoute))
        .finally(()=>setLoader(false))
    }
  };

  return (
    <>
      <Helmet>
        <title>{airport?.name || "Аэропорт"}</title>
      </Helmet>
      <BlockUi blocking={loader}>
        {airport && <>
          <Breadcrumbs aria-label="Breadcrumb" style={{paddingBottom: 15}}>
            {renderLocationsLinks(airport.navigation.previous)}
            <Typography color="textPrimary">{airport?.name?.length >0 ? airport.name :  airport.nameEn}</Typography>
          </Breadcrumbs>
        <AirportForm onSubmit={callback}
                                 deleteAction={deleteAction}
                                 edit
                                 data={airport}/>
        </>}
      </BlockUi>
    </>
  );
};

export default CityEditPage;
